import { useEffect } from 'react';

/**
 * Adds noindex, nofollow meta tag for pages that shouldn't be indexed (e.g. auth-required).
 * Prevents Google indexing issues when crawlers hit protected routes.
 */
const NoIndex = () => {
  useEffect(() => {
    let meta = document.querySelector('meta[name="robots"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'robots';
      document.head.appendChild(meta);
    }
    meta.content = 'noindex, nofollow';

    return () => {
      // Restore default on unmount
      meta.content = 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1';
    };
  }, []);

  return null;
};

export default NoIndex;
